var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/utils/macros.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["id"], 
["bound", "title"], 
function (l_id, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("id", l_id);
frame.set("bound", Object.prototype.hasOwnProperty.call(kwargs, "bound") ? kwargs["bound"] : "");frame.set("title", Object.prototype.hasOwnProperty.call(kwargs, "title") ? kwargs["title"] : "");var t_2 = "";t_2 += "<svg";
if(runtime.contextOrFrameLookup(context, frame, "bound")) {
t_2 += " viewBox=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bound"), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += ">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "title")) {
t_2 += "<title>";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
t_2 += "</title>";
;
}
t_2 += "\n    <use xlink:href=\"/static/app/front/sprite.svg?20260325#";
t_2 += runtime.suppressValue(l_id, env.opts.autoescape);
t_2 += "\"></use>\n    </svg>";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("svgSprite");
context.setVariable("svgSprite", macro_t_1);
output += "\n\n";
var macro_t_3 = runtime.makeMacro(
["component"], 
["mods", "classes", "data"], 
function (l_component, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("component", l_component);
frame.set("mods", Object.prototype.hasOwnProperty.call(kwargs, "mods") ? kwargs["mods"] : []);frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_4 = "";if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"item")) {
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"item");
frame.set("item", t_5, true);
if(frame.topLevel) {
context.setVariable("item", t_5);
}
if(frame.topLevel) {
context.addExport("item", t_5);
}
;
}
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate(l_component, false, "assets/app/front/utils/macros.jinja", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
callback(null,t_6);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
callback(null,t_8);});
});
tasks.push(
function(result, callback){
t_4 += result;
callback(null);
});
env.waterfall(tasks, function(){
t_4 += runtime.suppressValue((lineno = 11, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
});
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("includeComponent");
context.setVariable("includeComponent", macro_t_3);
output += "\n\n";
var macro_t_10 = runtime.makeMacro(
[], 
["breakpoint", "columns", "totalColumns", "hasLastGutter", "totalLastGutter", "hasPadding", "totalPadding"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("breakpoint", Object.prototype.hasOwnProperty.call(kwargs, "breakpoint") ? kwargs["breakpoint"] : 1440);frame.set("columns", Object.prototype.hasOwnProperty.call(kwargs, "columns") ? kwargs["columns"] : 0);frame.set("totalColumns", Object.prototype.hasOwnProperty.call(kwargs, "totalColumns") ? kwargs["totalColumns"] : 12);frame.set("hasLastGutter", Object.prototype.hasOwnProperty.call(kwargs, "hasLastGutter") ? kwargs["hasLastGutter"] : 0);frame.set("totalLastGutter", Object.prototype.hasOwnProperty.call(kwargs, "totalLastGutter") ? kwargs["totalLastGutter"] : 0);frame.set("hasPadding", Object.prototype.hasOwnProperty.call(kwargs, "hasPadding") ? kwargs["hasPadding"] : 0);frame.set("totalPadding", Object.prototype.hasOwnProperty.call(kwargs, "totalPadding") ? kwargs["totalPadding"] : 0);var t_11 = "";if(runtime.contextOrFrameLookup(context, frame, "breakpoint") == 1024) {
t_11 += "\n        ";
var t_12;
t_12 = 48;
frame.set("gutter", t_12, true);
if(frame.topLevel) {
context.setVariable("gutter", t_12);
}
if(frame.topLevel) {
context.addExport("gutter", t_12);
}
t_11 += "\n    ";
;
}
else {
t_11 += "\n        ";
var t_13;
t_13 = 32;
frame.set("gutter", t_13, true);
if(frame.topLevel) {
context.setVariable("gutter", t_13);
}
if(frame.topLevel) {
context.addExport("gutter", t_13);
}
t_11 += "\n    ";
;
}
t_11 += "\n    ";
var t_14;
t_14 = (runtime.contextOrFrameLookup(context, frame, "totalColumns") - 1) * runtime.contextOrFrameLookup(context, frame, "gutter") - runtime.contextOrFrameLookup(context, frame, "totalLastGutter") * runtime.contextOrFrameLookup(context, frame, "gutter") - runtime.contextOrFrameLookup(context, frame, "totalPadding") * runtime.contextOrFrameLookup(context, frame, "gutter");
frame.set("allFixedSizes", t_14, true);
if(frame.topLevel) {
context.setVariable("allFixedSizes", t_14);
}
if(frame.topLevel) {
context.addExport("allFixedSizes", t_14);
}
t_11 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "columns") - 1 > 0) {
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "columns") - 1) * runtime.contextOrFrameLookup(context, frame, "gutter") + runtime.contextOrFrameLookup(context, frame, "hasLastGutter") * runtime.contextOrFrameLookup(context, frame, "gutter");
frame.set("allGutters", t_15, true);
if(frame.topLevel) {
context.setVariable("allGutters", t_15);
}
if(frame.topLevel) {
context.addExport("allGutters", t_15);
}
;
}
else {
var t_16;
t_16 = runtime.contextOrFrameLookup(context, frame, "hasLastGutter") * runtime.contextOrFrameLookup(context, frame, "gutter");
frame.set("allGutters", t_16, true);
if(frame.topLevel) {
context.setVariable("allGutters", t_16);
}
if(frame.topLevel) {
context.addExport("allGutters", t_16);
}
;
}
t_11 += "\n    calc((100% - ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "allFixedSizes"), env.opts.autoescape);
t_11 += "px) / ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "totalColumns"), env.opts.autoescape);
t_11 += " * ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "columns"), env.opts.autoescape);
t_11 += " + ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "allGutters"), env.opts.autoescape);
t_11 += "px + ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hasPadding"), env.opts.autoescape);
t_11 += " * ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "gutter"), env.opts.autoescape);
t_11 += "px / 2)";
;
frame = callerFrame;
return new runtime.SafeString(t_11);
});
context.addExport("calcgrid");
context.setVariable("calcgrid", macro_t_10);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/utils/macros.jinja"] , dependencies)